/**
 * Коды автоматизации
 */
export default class AdminAutomationsEnums
{
    public static readonly DEAL_TYPE = 1;
    public static readonly ENUMERATE_TYPE = 3;

    public static readonly DEAL_TYPE_NAME = 'Deal';
    public static readonly ENUMERATE_TYPE_NAME = 'Enumerate';
}
